/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Phrism SMCR API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  unref
} from 'vue';
import type {
  MaybeRef
} from 'vue';

import type {
  BulkInviteRequest,
  BulkInviteResponse,
  CheckPersonEmailAvailabilityParams,
  CreateAdminPersonRequest,
  CreateOrganisationRequest,
  CreateOrganisationalFunctionRequest,
  CreatePersonRequest,
  CreateRegulatoryFunctionRequest,
  CurrentUserDto,
  EditPersonRequest,
  EmailAvailabilityResponse,
  EmailTemplateTestRequest,
  EmailTestRequest,
  GetOrganisationsParams,
  GetRegulatoryFunctionsParams,
  InvitePersonRequest,
  LineManagerCandidateResponse,
  ListLineManagerCandidatesParams,
  ListPeopleParams,
  ListRegulatoryFunctionsParams,
  OnboardingResponse,
  OrganisationResponse,
  OrganisationalFunctionDto,
  PersonDetailResponse,
  PersonResponse,
  PersonResponsePagedResponse,
  ProblemDetails,
  ReInvitePersonRequest,
  RegulatoryFunctionDto,
  RegulatoryFunctionResponse,
  UpdateAdminPersonRequest,
  UpdateOrganisationRequest,
  UpdateRegulatoryFunctionRequest
} from './models';

import { customInstance } from './mutator';
export const createAdminPerson = (
    orgId: MaybeRef<string>,
    createAdminPersonRequest: MaybeRef<CreateAdminPersonRequest>,
 signal?: AbortSignal
) => {
      orgId = unref(orgId);
createAdminPersonRequest = unref(createAdminPersonRequest);

      return customInstance<PersonResponse>(
      {url: `/api/admin/organisations/${orgId}/people`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAdminPersonRequest, signal
    },
      );
    }



export const getCreateAdminPersonMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminPerson>>, TError,{orgId: string;data: CreateAdminPersonRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAdminPerson>>, TError,{orgId: string;data: CreateAdminPersonRequest}, TContext> => {

const mutationKey = ['createAdminPerson'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAdminPerson>>, {orgId: string;data: CreateAdminPersonRequest}> = (props) => {
          const {orgId,data} = props ?? {};

          return  createAdminPerson(orgId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAdminPersonMutationResult = NonNullable<Awaited<ReturnType<typeof createAdminPerson>>>
    export type CreateAdminPersonMutationBody = CreateAdminPersonRequest
    export type CreateAdminPersonMutationError = ProblemDetails

    export const useCreateAdminPerson = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminPerson>>, TError,{orgId: string;data: CreateAdminPersonRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createAdminPerson>>,
        TError,
        {orgId: string;data: CreateAdminPersonRequest},
        TContext
      > => {
      return useMutation(getCreateAdminPersonMutationOptions(options), queryClient);
    }

export const updateAdminPerson = (
    orgId: MaybeRef<string>,
    id: MaybeRef<string>,
    updateAdminPersonRequest: MaybeRef<UpdateAdminPersonRequest>,
 signal?: AbortSignal
) => {
      orgId = unref(orgId);
id = unref(id);
updateAdminPersonRequest = unref(updateAdminPersonRequest);

      return customInstance<PersonResponse>(
      {url: `/api/admin/organisations/${orgId}/people/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateAdminPersonRequest, signal
    },
      );
    }



export const getUpdateAdminPersonMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminPerson>>, TError,{orgId: string;id: string;data: UpdateAdminPersonRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAdminPerson>>, TError,{orgId: string;id: string;data: UpdateAdminPersonRequest}, TContext> => {

const mutationKey = ['updateAdminPerson'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdminPerson>>, {orgId: string;id: string;data: UpdateAdminPersonRequest}> = (props) => {
          const {orgId,id,data} = props ?? {};

          return  updateAdminPerson(orgId,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdminPersonMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdminPerson>>>
    export type UpdateAdminPersonMutationBody = UpdateAdminPersonRequest
    export type UpdateAdminPersonMutationError = ProblemDetails

    export const useUpdateAdminPerson = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminPerson>>, TError,{orgId: string;id: string;data: UpdateAdminPersonRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateAdminPerson>>,
        TError,
        {orgId: string;id: string;data: UpdateAdminPersonRequest},
        TContext
      > => {
      return useMutation(getUpdateAdminPersonMutationOptions(options), queryClient);
    }

export const bulkInviteAdminPeople = (
    orgId: MaybeRef<string>,
    bulkInviteRequest: MaybeRef<BulkInviteRequest>,
 signal?: AbortSignal
) => {
      orgId = unref(orgId);
bulkInviteRequest = unref(bulkInviteRequest);

      return customInstance<BulkInviteResponse>(
      {url: `/api/admin/organisations/${orgId}/people/bulk-invite`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkInviteRequest, signal
    },
      );
    }



export const getBulkInviteAdminPeopleMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkInviteAdminPeople>>, TError,{orgId: string;data: BulkInviteRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof bulkInviteAdminPeople>>, TError,{orgId: string;data: BulkInviteRequest}, TContext> => {

const mutationKey = ['bulkInviteAdminPeople'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkInviteAdminPeople>>, {orgId: string;data: BulkInviteRequest}> = (props) => {
          const {orgId,data} = props ?? {};

          return  bulkInviteAdminPeople(orgId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkInviteAdminPeopleMutationResult = NonNullable<Awaited<ReturnType<typeof bulkInviteAdminPeople>>>
    export type BulkInviteAdminPeopleMutationBody = BulkInviteRequest
    export type BulkInviteAdminPeopleMutationError = ProblemDetails

    export const useBulkInviteAdminPeople = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkInviteAdminPeople>>, TError,{orgId: string;data: BulkInviteRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof bulkInviteAdminPeople>>,
        TError,
        {orgId: string;data: BulkInviteRequest},
        TContext
      > => {
      return useMutation(getBulkInviteAdminPeopleMutationOptions(options), queryClient);
    }

export const revokeAdminPersonInvitation = (
    orgId: MaybeRef<string>,
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      orgId = unref(orgId);
id = unref(id);

      return customInstance<void>(
      {url: `/api/admin/organisations/${orgId}/people/${id}/revoke-invitation`, method: 'POST', signal
    },
      );
    }



export const getRevokeAdminPersonInvitationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeAdminPersonInvitation>>, TError,{orgId: string;id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof revokeAdminPersonInvitation>>, TError,{orgId: string;id: string}, TContext> => {

const mutationKey = ['revokeAdminPersonInvitation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeAdminPersonInvitation>>, {orgId: string;id: string}> = (props) => {
          const {orgId,id} = props ?? {};

          return  revokeAdminPersonInvitation(orgId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeAdminPersonInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof revokeAdminPersonInvitation>>>

    export type RevokeAdminPersonInvitationMutationError = ProblemDetails

    export const useRevokeAdminPersonInvitation = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeAdminPersonInvitation>>, TError,{orgId: string;id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof revokeAdminPersonInvitation>>,
        TError,
        {orgId: string;id: string},
        TContext
      > => {
      return useMutation(getRevokeAdminPersonInvitationMutationOptions(options), queryClient);
    }

export const resendAdminPersonInvitation = (
    orgId: MaybeRef<string>,
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      orgId = unref(orgId);
id = unref(id);

      return customInstance<void>(
      {url: `/api/admin/organisations/${orgId}/people/${id}/resend-invitation`, method: 'POST', signal
    },
      );
    }



export const getResendAdminPersonInvitationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendAdminPersonInvitation>>, TError,{orgId: string;id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof resendAdminPersonInvitation>>, TError,{orgId: string;id: string}, TContext> => {

const mutationKey = ['resendAdminPersonInvitation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendAdminPersonInvitation>>, {orgId: string;id: string}> = (props) => {
          const {orgId,id} = props ?? {};

          return  resendAdminPersonInvitation(orgId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResendAdminPersonInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof resendAdminPersonInvitation>>>

    export type ResendAdminPersonInvitationMutationError = ProblemDetails

    export const useResendAdminPersonInvitation = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendAdminPersonInvitation>>, TError,{orgId: string;id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof resendAdminPersonInvitation>>,
        TError,
        {orgId: string;id: string},
        TContext
      > => {
      return useMutation(getResendAdminPersonInvitationMutationOptions(options), queryClient);
    }

export const clerkWebhook = (

 signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/webhooks/clerk`, method: 'POST', signal
    },
      );
    }



export const getClerkWebhookMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clerkWebhook>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clerkWebhook>>, TError,void, TContext> => {

const mutationKey = ['clerkWebhook'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clerkWebhook>>, void> = () => {


          return  clerkWebhook()
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClerkWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof clerkWebhook>>>

    export type ClerkWebhookMutationError = ProblemDetails

    export const useClerkWebhook = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clerkWebhook>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof clerkWebhook>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getClerkWebhookMutationOptions(options), queryClient);
    }

export const getCompany = (

 signal?: AbortSignal
) => {


      return customInstance<OrganisationResponse>(
      {url: `/api/Company`, method: 'GET', signal
    },
      );
    }




export const getGetCompanyQueryKey = () => {
    return [
    'api','Company'
    ] as const;
    }


export const getGetCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getCompany>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetCompanyQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompany>>> = ({ signal }) => getCompany(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>
}

export type GetCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getCompany>>>
export type GetCompanyQueryError = ProblemDetails



export function useGetCompany<TData = Awaited<ReturnType<typeof getCompany>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const updateCompany = (
    updateOrganisationRequest: MaybeRef<UpdateOrganisationRequest>,
 signal?: AbortSignal
) => {
      updateOrganisationRequest = unref(updateOrganisationRequest);

      return customInstance<OrganisationResponse>(
      {url: `/api/Company`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateOrganisationRequest, signal
    },
      );
    }



export const getUpdateCompanyMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompany>>, TError,{data: UpdateOrganisationRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateCompany>>, TError,{data: UpdateOrganisationRequest}, TContext> => {

const mutationKey = ['updateCompany'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCompany>>, {data: UpdateOrganisationRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateCompany(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof updateCompany>>>
    export type UpdateCompanyMutationBody = UpdateOrganisationRequest
    export type UpdateCompanyMutationError = ProblemDetails

    export const useUpdateCompany = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompany>>, TError,{data: UpdateOrganisationRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateCompany>>,
        TError,
        {data: UpdateOrganisationRequest},
        TContext
      > => {
      return useMutation(getUpdateCompanyMutationOptions(options), queryClient);
    }

export const getCurrentUser = (

 signal?: AbortSignal
) => {


      return customInstance<CurrentUserDto>(
      {url: `/api/me`, method: 'GET', signal
    },
      );
    }




export const getGetCurrentUserQueryKey = () => {
    return [
    'api','me'
    ] as const;
    }


export const getGetCurrentUserQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetCurrentUserQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentUser>>> = ({ signal }) => getCurrentUser(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>
}

export type GetCurrentUserQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentUser>>>
export type GetCurrentUserQueryError = ProblemDetails



export function useGetCurrentUser<TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCurrentUserQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const getOnboarding = (

 signal?: AbortSignal
) => {


      return customInstance<OnboardingResponse>(
      {url: `/api/onboarding`, method: 'GET', signal
    },
      );
    }




export const getGetOnboardingQueryKey = () => {
    return [
    'api','onboarding'
    ] as const;
    }


export const getGetOnboardingQueryOptions = <TData = Awaited<ReturnType<typeof getOnboarding>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboarding>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetOnboardingQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnboarding>>> = ({ signal }) => getOnboarding(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOnboarding>>, TError, TData>
}

export type GetOnboardingQueryResult = NonNullable<Awaited<ReturnType<typeof getOnboarding>>>
export type GetOnboardingQueryError = unknown



export function useGetOnboarding<TData = Awaited<ReturnType<typeof getOnboarding>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnboarding>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOnboardingQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const completeOnboardingStep = (
    stepKey: MaybeRef<string>,
 signal?: AbortSignal
) => {
      stepKey = unref(stepKey);

      return customInstance<void>(
      {url: `/api/onboarding/steps/${stepKey}/complete`, method: 'POST', signal
    },
      );
    }



export const getCompleteOnboardingStepMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeOnboardingStep>>, TError,{stepKey: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof completeOnboardingStep>>, TError,{stepKey: string}, TContext> => {

const mutationKey = ['completeOnboardingStep'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeOnboardingStep>>, {stepKey: string}> = (props) => {
          const {stepKey} = props ?? {};

          return  completeOnboardingStep(stepKey,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteOnboardingStepMutationResult = NonNullable<Awaited<ReturnType<typeof completeOnboardingStep>>>

    export type CompleteOnboardingStepMutationError = ProblemDetails

    export const useCompleteOnboardingStep = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeOnboardingStep>>, TError,{stepKey: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof completeOnboardingStep>>,
        TError,
        {stepKey: string},
        TContext
      > => {
      return useMutation(getCompleteOnboardingStepMutationOptions(options), queryClient);
    }

export const dismissOnboarding = (

 signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/onboarding/dismiss`, method: 'POST', signal
    },
      );
    }



export const getDismissOnboardingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissOnboarding>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof dismissOnboarding>>, TError,void, TContext> => {

const mutationKey = ['dismissOnboarding'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dismissOnboarding>>, void> = () => {


          return  dismissOnboarding()
        }






  return  { mutationFn, ...mutationOptions }}

    export type DismissOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof dismissOnboarding>>>

    export type DismissOnboardingMutationError = unknown

    export const useDismissOnboarding = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissOnboarding>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof dismissOnboarding>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDismissOnboardingMutationOptions(options), queryClient);
    }

export const reopenOnboarding = (

 signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/onboarding/reopen`, method: 'POST', signal
    },
      );
    }



export const getReopenOnboardingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenOnboarding>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reopenOnboarding>>, TError,void, TContext> => {

const mutationKey = ['reopenOnboarding'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reopenOnboarding>>, void> = () => {


          return  reopenOnboarding()
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReopenOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof reopenOnboarding>>>

    export type ReopenOnboardingMutationError = unknown

    export const useReopenOnboarding = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenOnboarding>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof reopenOnboarding>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getReopenOnboardingMutationOptions(options), queryClient);
    }

export const getOrganisationalFunctions = (

 signal?: AbortSignal
) => {


      return customInstance<OrganisationalFunctionDto[]>(
      {url: `/api/OrganisationalFunctions`, method: 'GET', signal
    },
      );
    }




export const getGetOrganisationalFunctionsQueryKey = () => {
    return [
    'api','OrganisationalFunctions'
    ] as const;
    }


export const getGetOrganisationalFunctionsQueryOptions = <TData = Awaited<ReturnType<typeof getOrganisationalFunctions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganisationalFunctions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetOrganisationalFunctionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganisationalFunctions>>> = ({ signal }) => getOrganisationalFunctions(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganisationalFunctions>>, TError, TData>
}

export type GetOrganisationalFunctionsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganisationalFunctions>>>
export type GetOrganisationalFunctionsQueryError = unknown



export function useGetOrganisationalFunctions<TData = Awaited<ReturnType<typeof getOrganisationalFunctions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganisationalFunctions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganisationalFunctionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const addOrganisationalFunction = (
    createOrganisationalFunctionRequest: MaybeRef<CreateOrganisationalFunctionRequest>,
 signal?: AbortSignal
) => {
      createOrganisationalFunctionRequest = unref(createOrganisationalFunctionRequest);

      return customInstance<OrganisationalFunctionDto>(
      {url: `/api/OrganisationalFunctions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrganisationalFunctionRequest, signal
    },
      );
    }



export const getAddOrganisationalFunctionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addOrganisationalFunction>>, TError,{data: CreateOrganisationalFunctionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addOrganisationalFunction>>, TError,{data: CreateOrganisationalFunctionRequest}, TContext> => {

const mutationKey = ['addOrganisationalFunction'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addOrganisationalFunction>>, {data: CreateOrganisationalFunctionRequest}> = (props) => {
          const {data} = props ?? {};

          return  addOrganisationalFunction(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddOrganisationalFunctionMutationResult = NonNullable<Awaited<ReturnType<typeof addOrganisationalFunction>>>
    export type AddOrganisationalFunctionMutationBody = CreateOrganisationalFunctionRequest
    export type AddOrganisationalFunctionMutationError = ProblemDetails

    export const useAddOrganisationalFunction = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addOrganisationalFunction>>, TError,{data: CreateOrganisationalFunctionRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof addOrganisationalFunction>>,
        TError,
        {data: CreateOrganisationalFunctionRequest},
        TContext
      > => {
      return useMutation(getAddOrganisationalFunctionMutationOptions(options), queryClient);
    }

export const removeOrganisationalFunction = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);

      return customInstance<void>(
      {url: `/api/OrganisationalFunctions/${id}`, method: 'DELETE', signal
    },
      );
    }



export const getRemoveOrganisationalFunctionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeOrganisationalFunction>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof removeOrganisationalFunction>>, TError,{id: string}, TContext> => {

const mutationKey = ['removeOrganisationalFunction'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeOrganisationalFunction>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  removeOrganisationalFunction(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveOrganisationalFunctionMutationResult = NonNullable<Awaited<ReturnType<typeof removeOrganisationalFunction>>>

    export type RemoveOrganisationalFunctionMutationError = ProblemDetails

    export const useRemoveOrganisationalFunction = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeOrganisationalFunction>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof removeOrganisationalFunction>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getRemoveOrganisationalFunctionMutationOptions(options), queryClient);
    }

export const getOrganisations = (
    params?: MaybeRef<GetOrganisationsParams>,
 signal?: AbortSignal
) => {
      params = unref(params);

      return customInstance<OrganisationResponse[]>(
      {url: `/api/admin/Organisations`, method: 'GET',
        params: unref(params), signal
    },
      );
    }




export const getGetOrganisationsQueryKey = (params?: MaybeRef<GetOrganisationsParams>,) => {
    return [
    'api','admin','Organisations', ...(params ? [params] : [])
    ] as const;
    }


export const getGetOrganisationsQueryOptions = <TData = Awaited<ReturnType<typeof getOrganisations>>, TError = unknown>(params?: MaybeRef<GetOrganisationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganisations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetOrganisationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganisations>>> = ({ signal }) => getOrganisations(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganisations>>, TError, TData>
}

export type GetOrganisationsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganisations>>>
export type GetOrganisationsQueryError = unknown



export function useGetOrganisations<TData = Awaited<ReturnType<typeof getOrganisations>>, TError = unknown>(
 params?: MaybeRef<GetOrganisationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganisations>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganisationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const createOrganisation = (
    createOrganisationRequest: MaybeRef<CreateOrganisationRequest>,
 signal?: AbortSignal
) => {
      createOrganisationRequest = unref(createOrganisationRequest);

      return customInstance<OrganisationResponse>(
      {url: `/api/admin/Organisations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrganisationRequest, signal
    },
      );
    }



export const getCreateOrganisationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrganisation>>, TError,{data: CreateOrganisationRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createOrganisation>>, TError,{data: CreateOrganisationRequest}, TContext> => {

const mutationKey = ['createOrganisation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrganisation>>, {data: CreateOrganisationRequest}> = (props) => {
          const {data} = props ?? {};

          return  createOrganisation(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOrganisationMutationResult = NonNullable<Awaited<ReturnType<typeof createOrganisation>>>
    export type CreateOrganisationMutationBody = CreateOrganisationRequest
    export type CreateOrganisationMutationError = ProblemDetails

    export const useCreateOrganisation = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrganisation>>, TError,{data: CreateOrganisationRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createOrganisation>>,
        TError,
        {data: CreateOrganisationRequest},
        TContext
      > => {
      return useMutation(getCreateOrganisationMutationOptions(options), queryClient);
    }

export const getOrganisationById = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);

      return customInstance<OrganisationResponse>(
      {url: `/api/admin/Organisations/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetOrganisationByIdQueryKey = (id: MaybeRef<string>,) => {
    return [
    'api','admin','Organisations',id
    ] as const;
    }


export const getGetOrganisationByIdQueryOptions = <TData = Awaited<ReturnType<typeof getOrganisationById>>, TError = ProblemDetails>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganisationById>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetOrganisationByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganisationById>>> = ({ signal }) => getOrganisationById(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganisationById>>, TError, TData>
}

export type GetOrganisationByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganisationById>>>
export type GetOrganisationByIdQueryError = ProblemDetails



export function useGetOrganisationById<TData = Awaited<ReturnType<typeof getOrganisationById>>, TError = ProblemDetails>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganisationById>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganisationByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const updateOrganisation = (
    id: MaybeRef<string>,
    updateOrganisationRequest: MaybeRef<UpdateOrganisationRequest>,
 signal?: AbortSignal
) => {
      id = unref(id);
updateOrganisationRequest = unref(updateOrganisationRequest);

      return customInstance<OrganisationResponse>(
      {url: `/api/admin/Organisations/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateOrganisationRequest, signal
    },
      );
    }



export const getUpdateOrganisationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganisation>>, TError,{id: string;data: UpdateOrganisationRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateOrganisation>>, TError,{id: string;data: UpdateOrganisationRequest}, TContext> => {

const mutationKey = ['updateOrganisation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrganisation>>, {id: string;data: UpdateOrganisationRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOrganisation(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrganisationMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrganisation>>>
    export type UpdateOrganisationMutationBody = UpdateOrganisationRequest
    export type UpdateOrganisationMutationError = ProblemDetails

    export const useUpdateOrganisation = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganisation>>, TError,{id: string;data: UpdateOrganisationRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateOrganisation>>,
        TError,
        {id: string;data: UpdateOrganisationRequest},
        TContext
      > => {
      return useMutation(getUpdateOrganisationMutationOptions(options), queryClient);
    }

export const deleteOrganisation = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);

      return customInstance<void>(
      {url: `/api/admin/Organisations/${id}`, method: 'DELETE', signal
    },
      );
    }



export const getDeleteOrganisationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrganisation>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteOrganisation>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteOrganisation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOrganisation>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteOrganisation(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteOrganisationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOrganisation>>>

    export type DeleteOrganisationMutationError = ProblemDetails

    export const useDeleteOrganisation = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrganisation>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteOrganisation>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteOrganisationMutationOptions(options), queryClient);
    }

export const getOrganisationPeople = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);

      return customInstance<PersonResponse[]>(
      {url: `/api/admin/Organisations/${id}/people`, method: 'GET', signal
    },
      );
    }




export const getGetOrganisationPeopleQueryKey = (id: MaybeRef<string>,) => {
    return [
    'api','admin','Organisations',id,'people'
    ] as const;
    }


export const getGetOrganisationPeopleQueryOptions = <TData = Awaited<ReturnType<typeof getOrganisationPeople>>, TError = ProblemDetails>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganisationPeople>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetOrganisationPeopleQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganisationPeople>>> = ({ signal }) => getOrganisationPeople(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganisationPeople>>, TError, TData>
}

export type GetOrganisationPeopleQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganisationPeople>>>
export type GetOrganisationPeopleQueryError = ProblemDetails



export function useGetOrganisationPeople<TData = Awaited<ReturnType<typeof getOrganisationPeople>>, TError = ProblemDetails>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganisationPeople>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganisationPeopleQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const listPeople = (
    params?: MaybeRef<ListPeopleParams>,
 signal?: AbortSignal
) => {
      params = unref(params);

      return customInstance<PersonResponsePagedResponse>(
      {url: `/api/People`, method: 'GET',
        params: unref(params), signal
    },
      );
    }




export const getListPeopleQueryKey = (params?: MaybeRef<ListPeopleParams>,) => {
    return [
    'api','People', ...(params ? [params] : [])
    ] as const;
    }


export const getListPeopleQueryOptions = <TData = Awaited<ReturnType<typeof listPeople>>, TError = ProblemDetails>(params?: MaybeRef<ListPeopleParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPeople>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListPeopleQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPeople>>> = ({ signal }) => listPeople(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPeople>>, TError, TData>
}

export type ListPeopleQueryResult = NonNullable<Awaited<ReturnType<typeof listPeople>>>
export type ListPeopleQueryError = ProblemDetails



export function useListPeople<TData = Awaited<ReturnType<typeof listPeople>>, TError = ProblemDetails>(
 params?: MaybeRef<ListPeopleParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPeople>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPeopleQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const createPerson = (
    createPersonRequest: MaybeRef<CreatePersonRequest>,
 signal?: AbortSignal
) => {
      createPersonRequest = unref(createPersonRequest);

      return customInstance<PersonDetailResponse>(
      {url: `/api/People`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPersonRequest, signal
    },
      );
    }



export const getCreatePersonMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPerson>>, TError,{data: CreatePersonRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPerson>>, TError,{data: CreatePersonRequest}, TContext> => {

const mutationKey = ['createPerson'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPerson>>, {data: CreatePersonRequest}> = (props) => {
          const {data} = props ?? {};

          return  createPerson(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePersonMutationResult = NonNullable<Awaited<ReturnType<typeof createPerson>>>
    export type CreatePersonMutationBody = CreatePersonRequest
    export type CreatePersonMutationError = ProblemDetails

    export const useCreatePerson = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPerson>>, TError,{data: CreatePersonRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createPerson>>,
        TError,
        {data: CreatePersonRequest},
        TContext
      > => {
      return useMutation(getCreatePersonMutationOptions(options), queryClient);
    }

export const listLineManagerCandidates = (
    params?: MaybeRef<ListLineManagerCandidatesParams>,
 signal?: AbortSignal
) => {
      params = unref(params);

      return customInstance<LineManagerCandidateResponse[]>(
      {url: `/api/People/line-manager-candidates`, method: 'GET',
        params: unref(params), signal
    },
      );
    }




export const getListLineManagerCandidatesQueryKey = (params?: MaybeRef<ListLineManagerCandidatesParams>,) => {
    return [
    'api','People','line-manager-candidates', ...(params ? [params] : [])
    ] as const;
    }


export const getListLineManagerCandidatesQueryOptions = <TData = Awaited<ReturnType<typeof listLineManagerCandidates>>, TError = unknown>(params?: MaybeRef<ListLineManagerCandidatesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLineManagerCandidates>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListLineManagerCandidatesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLineManagerCandidates>>> = ({ signal }) => listLineManagerCandidates(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLineManagerCandidates>>, TError, TData>
}

export type ListLineManagerCandidatesQueryResult = NonNullable<Awaited<ReturnType<typeof listLineManagerCandidates>>>
export type ListLineManagerCandidatesQueryError = unknown



export function useListLineManagerCandidates<TData = Awaited<ReturnType<typeof listLineManagerCandidates>>, TError = unknown>(
 params?: MaybeRef<ListLineManagerCandidatesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLineManagerCandidates>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLineManagerCandidatesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const listPeopleJobTitles = (

 signal?: AbortSignal
) => {


      return customInstance<string[]>(
      {url: `/api/People/job-titles`, method: 'GET', signal
    },
      );
    }




export const getListPeopleJobTitlesQueryKey = () => {
    return [
    'api','People','job-titles'
    ] as const;
    }


export const getListPeopleJobTitlesQueryOptions = <TData = Awaited<ReturnType<typeof listPeopleJobTitles>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPeopleJobTitles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListPeopleJobTitlesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPeopleJobTitles>>> = ({ signal }) => listPeopleJobTitles(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPeopleJobTitles>>, TError, TData>
}

export type ListPeopleJobTitlesQueryResult = NonNullable<Awaited<ReturnType<typeof listPeopleJobTitles>>>
export type ListPeopleJobTitlesQueryError = unknown



export function useListPeopleJobTitles<TData = Awaited<ReturnType<typeof listPeopleJobTitles>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPeopleJobTitles>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPeopleJobTitlesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const getPerson = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);

      return customInstance<PersonDetailResponse>(
      {url: `/api/People/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetPersonQueryKey = (id: MaybeRef<string>,) => {
    return [
    'api','People',id
    ] as const;
    }


export const getGetPersonQueryOptions = <TData = Awaited<ReturnType<typeof getPerson>>, TError = ProblemDetails>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetPersonQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPerson>>> = ({ signal }) => getPerson(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>
}

export type GetPersonQueryResult = NonNullable<Awaited<ReturnType<typeof getPerson>>>
export type GetPersonQueryError = ProblemDetails



export function useGetPerson<TData = Awaited<ReturnType<typeof getPerson>>, TError = ProblemDetails>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const editPerson = (
    id: MaybeRef<string>,
    editPersonRequest: MaybeRef<EditPersonRequest>,
 signal?: AbortSignal
) => {
      id = unref(id);
editPersonRequest = unref(editPersonRequest);

      return customInstance<PersonDetailResponse>(
      {url: `/api/People/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: editPersonRequest, signal
    },
      );
    }



export const getEditPersonMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editPerson>>, TError,{id: string;data: EditPersonRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof editPerson>>, TError,{id: string;data: EditPersonRequest}, TContext> => {

const mutationKey = ['editPerson'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editPerson>>, {id: string;data: EditPersonRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  editPerson(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditPersonMutationResult = NonNullable<Awaited<ReturnType<typeof editPerson>>>
    export type EditPersonMutationBody = EditPersonRequest
    export type EditPersonMutationError = ProblemDetails

    export const useEditPerson = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editPerson>>, TError,{id: string;data: EditPersonRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof editPerson>>,
        TError,
        {id: string;data: EditPersonRequest},
        TContext
      > => {
      return useMutation(getEditPersonMutationOptions(options), queryClient);
    }

export const reInvitePerson = (
    id: MaybeRef<string>,
    reInvitePersonRequest: MaybeRef<ReInvitePersonRequest>,
 signal?: AbortSignal
) => {
      id = unref(id);
reInvitePersonRequest = unref(reInvitePersonRequest);

      return customInstance<void>(
      {url: `/api/People/${id}/re-invite`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reInvitePersonRequest, signal
    },
      );
    }



export const getReInvitePersonMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reInvitePerson>>, TError,{id: string;data: ReInvitePersonRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reInvitePerson>>, TError,{id: string;data: ReInvitePersonRequest}, TContext> => {

const mutationKey = ['reInvitePerson'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reInvitePerson>>, {id: string;data: ReInvitePersonRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  reInvitePerson(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReInvitePersonMutationResult = NonNullable<Awaited<ReturnType<typeof reInvitePerson>>>
    export type ReInvitePersonMutationBody = ReInvitePersonRequest
    export type ReInvitePersonMutationError = ProblemDetails

    export const useReInvitePerson = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reInvitePerson>>, TError,{id: string;data: ReInvitePersonRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof reInvitePerson>>,
        TError,
        {id: string;data: ReInvitePersonRequest},
        TContext
      > => {
      return useMutation(getReInvitePersonMutationOptions(options), queryClient);
    }

export const invitePerson = (
    invitePersonRequest: MaybeRef<InvitePersonRequest>,
 signal?: AbortSignal
) => {
      invitePersonRequest = unref(invitePersonRequest);

      return customInstance<PersonDetailResponse>(
      {url: `/api/People/invite`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: invitePersonRequest, signal
    },
      );
    }



export const getInvitePersonMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invitePerson>>, TError,{data: InvitePersonRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof invitePerson>>, TError,{data: InvitePersonRequest}, TContext> => {

const mutationKey = ['invitePerson'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof invitePerson>>, {data: InvitePersonRequest}> = (props) => {
          const {data} = props ?? {};

          return  invitePerson(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InvitePersonMutationResult = NonNullable<Awaited<ReturnType<typeof invitePerson>>>
    export type InvitePersonMutationBody = InvitePersonRequest
    export type InvitePersonMutationError = ProblemDetails

    export const useInvitePerson = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invitePerson>>, TError,{data: InvitePersonRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof invitePerson>>,
        TError,
        {data: InvitePersonRequest},
        TContext
      > => {
      return useMutation(getInvitePersonMutationOptions(options), queryClient);
    }

export const cancelEmailChange = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);

      return customInstance<void>(
      {url: `/api/People/${id}/email-change`, method: 'DELETE', signal
    },
      );
    }



export const getCancelEmailChangeMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelEmailChange>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cancelEmailChange>>, TError,{id: string}, TContext> => {

const mutationKey = ['cancelEmailChange'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelEmailChange>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  cancelEmailChange(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelEmailChangeMutationResult = NonNullable<Awaited<ReturnType<typeof cancelEmailChange>>>

    export type CancelEmailChangeMutationError = ProblemDetails

    export const useCancelEmailChange = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelEmailChange>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof cancelEmailChange>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getCancelEmailChangeMutationOptions(options), queryClient);
    }

export const acceptPersonInvitation = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);

      return customInstance<void>(
      {url: `/api/People/${id}/accept-invitation`, method: 'POST', signal
    },
      );
    }



export const getAcceptPersonInvitationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptPersonInvitation>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof acceptPersonInvitation>>, TError,{id: string}, TContext> => {

const mutationKey = ['acceptPersonInvitation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptPersonInvitation>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  acceptPersonInvitation(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptPersonInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof acceptPersonInvitation>>>

    export type AcceptPersonInvitationMutationError = ProblemDetails

    export const useAcceptPersonInvitation = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptPersonInvitation>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof acceptPersonInvitation>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getAcceptPersonInvitationMutationOptions(options), queryClient);
    }

export const cancelPersonInvitation = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);

      return customInstance<void>(
      {url: `/api/People/${id}/cancel-invitation`, method: 'POST', signal
    },
      );
    }



export const getCancelPersonInvitationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelPersonInvitation>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cancelPersonInvitation>>, TError,{id: string}, TContext> => {

const mutationKey = ['cancelPersonInvitation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelPersonInvitation>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  cancelPersonInvitation(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelPersonInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof cancelPersonInvitation>>>

    export type CancelPersonInvitationMutationError = ProblemDetails

    export const useCancelPersonInvitation = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelPersonInvitation>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof cancelPersonInvitation>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getCancelPersonInvitationMutationOptions(options), queryClient);
    }

export const checkPersonEmailAvailability = (
    params?: MaybeRef<CheckPersonEmailAvailabilityParams>,
 signal?: AbortSignal
) => {
      params = unref(params);

      return customInstance<EmailAvailabilityResponse>(
      {url: `/api/People/check-email-availability`, method: 'GET',
        params: unref(params), signal
    },
      );
    }




export const getCheckPersonEmailAvailabilityQueryKey = (params?: MaybeRef<CheckPersonEmailAvailabilityParams>,) => {
    return [
    'api','People','check-email-availability', ...(params ? [params] : [])
    ] as const;
    }


export const getCheckPersonEmailAvailabilityQueryOptions = <TData = Awaited<ReturnType<typeof checkPersonEmailAvailability>>, TError = ProblemDetails>(params?: MaybeRef<CheckPersonEmailAvailabilityParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkPersonEmailAvailability>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getCheckPersonEmailAvailabilityQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof checkPersonEmailAvailability>>> = ({ signal }) => checkPersonEmailAvailability(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof checkPersonEmailAvailability>>, TError, TData>
}

export type CheckPersonEmailAvailabilityQueryResult = NonNullable<Awaited<ReturnType<typeof checkPersonEmailAvailability>>>
export type CheckPersonEmailAvailabilityQueryError = ProblemDetails



export function useCheckPersonEmailAvailability<TData = Awaited<ReturnType<typeof checkPersonEmailAvailability>>, TError = ProblemDetails>(
 params?: MaybeRef<CheckPersonEmailAvailabilityParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkPersonEmailAvailability>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCheckPersonEmailAvailabilityQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const devEmailTest = (
    emailTestRequest: MaybeRef<EmailTestRequest>,
 signal?: AbortSignal
) => {
      emailTestRequest = unref(emailTestRequest);

      return customInstance<void>(
      {url: `/dev/email-test`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: emailTestRequest, signal
    },
      );
    }



export const getDevEmailTestMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devEmailTest>>, TError,{data: EmailTestRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof devEmailTest>>, TError,{data: EmailTestRequest}, TContext> => {

const mutationKey = ['devEmailTest'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof devEmailTest>>, {data: EmailTestRequest}> = (props) => {
          const {data} = props ?? {};

          return  devEmailTest(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DevEmailTestMutationResult = NonNullable<Awaited<ReturnType<typeof devEmailTest>>>
    export type DevEmailTestMutationBody = EmailTestRequest
    export type DevEmailTestMutationError = unknown

    export const useDevEmailTest = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devEmailTest>>, TError,{data: EmailTestRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof devEmailTest>>,
        TError,
        {data: EmailTestRequest},
        TContext
      > => {
      return useMutation(getDevEmailTestMutationOptions(options), queryClient);
    }

export const devEmailTemplateTest = (
    emailTemplateTestRequest: MaybeRef<EmailTemplateTestRequest>,
 signal?: AbortSignal
) => {
      emailTemplateTestRequest = unref(emailTemplateTestRequest);

      return customInstance<void>(
      {url: `/dev/email-template-test`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: emailTemplateTestRequest, signal
    },
      );
    }



export const getDevEmailTemplateTestMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devEmailTemplateTest>>, TError,{data: EmailTemplateTestRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof devEmailTemplateTest>>, TError,{data: EmailTemplateTestRequest}, TContext> => {

const mutationKey = ['devEmailTemplateTest'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof devEmailTemplateTest>>, {data: EmailTemplateTestRequest}> = (props) => {
          const {data} = props ?? {};

          return  devEmailTemplateTest(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DevEmailTemplateTestMutationResult = NonNullable<Awaited<ReturnType<typeof devEmailTemplateTest>>>
    export type DevEmailTemplateTestMutationBody = EmailTemplateTestRequest
    export type DevEmailTemplateTestMutationError = unknown

    export const useDevEmailTemplateTest = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devEmailTemplateTest>>, TError,{data: EmailTemplateTestRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof devEmailTemplateTest>>,
        TError,
        {data: EmailTemplateTestRequest},
        TContext
      > => {
      return useMutation(getDevEmailTemplateTestMutationOptions(options), queryClient);
    }

export const listRegulatoryFunctions = (
    params?: MaybeRef<ListRegulatoryFunctionsParams>,
 signal?: AbortSignal
) => {
      params = unref(params);

      return customInstance<RegulatoryFunctionResponse[]>(
      {url: `/api/admin/regulatory-functions`, method: 'GET',
        params: unref(params), signal
    },
      );
    }




export const getListRegulatoryFunctionsQueryKey = (params?: MaybeRef<ListRegulatoryFunctionsParams>,) => {
    return [
    'api','admin','regulatory-functions', ...(params ? [params] : [])
    ] as const;
    }


export const getListRegulatoryFunctionsQueryOptions = <TData = Awaited<ReturnType<typeof listRegulatoryFunctions>>, TError = unknown>(params?: MaybeRef<ListRegulatoryFunctionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRegulatoryFunctions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListRegulatoryFunctionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRegulatoryFunctions>>> = ({ signal }) => listRegulatoryFunctions(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRegulatoryFunctions>>, TError, TData>
}

export type ListRegulatoryFunctionsQueryResult = NonNullable<Awaited<ReturnType<typeof listRegulatoryFunctions>>>
export type ListRegulatoryFunctionsQueryError = unknown



export function useListRegulatoryFunctions<TData = Awaited<ReturnType<typeof listRegulatoryFunctions>>, TError = unknown>(
 params?: MaybeRef<ListRegulatoryFunctionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRegulatoryFunctions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRegulatoryFunctionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}





export const createRegulatoryFunction = (
    createRegulatoryFunctionRequest: MaybeRef<CreateRegulatoryFunctionRequest>,
 signal?: AbortSignal
) => {
      createRegulatoryFunctionRequest = unref(createRegulatoryFunctionRequest);

      return customInstance<RegulatoryFunctionResponse>(
      {url: `/api/admin/regulatory-functions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createRegulatoryFunctionRequest, signal
    },
      );
    }



export const getCreateRegulatoryFunctionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRegulatoryFunction>>, TError,{data: CreateRegulatoryFunctionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createRegulatoryFunction>>, TError,{data: CreateRegulatoryFunctionRequest}, TContext> => {

const mutationKey = ['createRegulatoryFunction'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRegulatoryFunction>>, {data: CreateRegulatoryFunctionRequest}> = (props) => {
          const {data} = props ?? {};

          return  createRegulatoryFunction(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRegulatoryFunctionMutationResult = NonNullable<Awaited<ReturnType<typeof createRegulatoryFunction>>>
    export type CreateRegulatoryFunctionMutationBody = CreateRegulatoryFunctionRequest
    export type CreateRegulatoryFunctionMutationError = ProblemDetails

    export const useCreateRegulatoryFunction = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRegulatoryFunction>>, TError,{data: CreateRegulatoryFunctionRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createRegulatoryFunction>>,
        TError,
        {data: CreateRegulatoryFunctionRequest},
        TContext
      > => {
      return useMutation(getCreateRegulatoryFunctionMutationOptions(options), queryClient);
    }

export const updateRegulatoryFunction = (
    id: MaybeRef<string>,
    updateRegulatoryFunctionRequest: MaybeRef<UpdateRegulatoryFunctionRequest>,
 signal?: AbortSignal
) => {
      id = unref(id);
updateRegulatoryFunctionRequest = unref(updateRegulatoryFunctionRequest);

      return customInstance<RegulatoryFunctionResponse>(
      {url: `/api/admin/regulatory-functions/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateRegulatoryFunctionRequest, signal
    },
      );
    }



export const getUpdateRegulatoryFunctionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRegulatoryFunction>>, TError,{id: string;data: UpdateRegulatoryFunctionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateRegulatoryFunction>>, TError,{id: string;data: UpdateRegulatoryFunctionRequest}, TContext> => {

const mutationKey = ['updateRegulatoryFunction'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRegulatoryFunction>>, {id: string;data: UpdateRegulatoryFunctionRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateRegulatoryFunction(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateRegulatoryFunctionMutationResult = NonNullable<Awaited<ReturnType<typeof updateRegulatoryFunction>>>
    export type UpdateRegulatoryFunctionMutationBody = UpdateRegulatoryFunctionRequest
    export type UpdateRegulatoryFunctionMutationError = ProblemDetails

    export const useUpdateRegulatoryFunction = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRegulatoryFunction>>, TError,{id: string;data: UpdateRegulatoryFunctionRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateRegulatoryFunction>>,
        TError,
        {id: string;data: UpdateRegulatoryFunctionRequest},
        TContext
      > => {
      return useMutation(getUpdateRegulatoryFunctionMutationOptions(options), queryClient);
    }

export const activateRegulatoryFunction = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);

      return customInstance<void>(
      {url: `/api/admin/regulatory-functions/${id}/activate`, method: 'PATCH', signal
    },
      );
    }



export const getActivateRegulatoryFunctionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateRegulatoryFunction>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof activateRegulatoryFunction>>, TError,{id: string}, TContext> => {

const mutationKey = ['activateRegulatoryFunction'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activateRegulatoryFunction>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  activateRegulatoryFunction(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivateRegulatoryFunctionMutationResult = NonNullable<Awaited<ReturnType<typeof activateRegulatoryFunction>>>

    export type ActivateRegulatoryFunctionMutationError = ProblemDetails

    export const useActivateRegulatoryFunction = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateRegulatoryFunction>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof activateRegulatoryFunction>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getActivateRegulatoryFunctionMutationOptions(options), queryClient);
    }

export const deactivateRegulatoryFunction = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);

      return customInstance<void>(
      {url: `/api/admin/regulatory-functions/${id}/deactivate`, method: 'PATCH', signal
    },
      );
    }



export const getDeactivateRegulatoryFunctionMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateRegulatoryFunction>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deactivateRegulatoryFunction>>, TError,{id: string}, TContext> => {

const mutationKey = ['deactivateRegulatoryFunction'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deactivateRegulatoryFunction>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deactivateRegulatoryFunction(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeactivateRegulatoryFunctionMutationResult = NonNullable<Awaited<ReturnType<typeof deactivateRegulatoryFunction>>>

    export type DeactivateRegulatoryFunctionMutationError = ProblemDetails

    export const useDeactivateRegulatoryFunction = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateRegulatoryFunction>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deactivateRegulatoryFunction>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeactivateRegulatoryFunctionMutationOptions(options), queryClient);
    }

export const getRegulatoryFunctions = (
    params?: MaybeRef<GetRegulatoryFunctionsParams>,
 signal?: AbortSignal
) => {
      params = unref(params);

      return customInstance<RegulatoryFunctionDto[]>(
      {url: `/api/RegulatoryFunctions`, method: 'GET',
        params: unref(params), signal
    },
      );
    }




export const getGetRegulatoryFunctionsQueryKey = (params?: MaybeRef<GetRegulatoryFunctionsParams>,) => {
    return [
    'api','RegulatoryFunctions', ...(params ? [params] : [])
    ] as const;
    }


export const getGetRegulatoryFunctionsQueryOptions = <TData = Awaited<ReturnType<typeof getRegulatoryFunctions>>, TError = unknown>(params?: MaybeRef<GetRegulatoryFunctionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegulatoryFunctions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetRegulatoryFunctionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegulatoryFunctions>>> = ({ signal }) => getRegulatoryFunctions(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRegulatoryFunctions>>, TError, TData>
}

export type GetRegulatoryFunctionsQueryResult = NonNullable<Awaited<ReturnType<typeof getRegulatoryFunctions>>>
export type GetRegulatoryFunctionsQueryError = unknown



export function useGetRegulatoryFunctions<TData = Awaited<ReturnType<typeof getRegulatoryFunctions>>, TError = unknown>(
 params?: MaybeRef<GetRegulatoryFunctionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegulatoryFunctions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRegulatoryFunctionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
